<template>
	<b-card no-body>
		<b-card-header class="p-2 d-flex justify-content-between align-items-center">
			<h4 class="mb-0">Disbursement Details</h4>
			<div class="d-flex align-items-center">
				<el-button type="primary" plain size="small" @click="$refs.drawer_account_statement.show()" >
					View Account Statement
				</el-button>
				<el-button type="primary" plain size="small" @click="openModal()" icon="el-icon-plus" >
					Add Disbursement
				</el-button>
			</div>
		</b-card-header>
		<div class="card-table-simple" v-loading="is_loading">
			<b-table-simple responsive class="mb-0">
				<b-thead>
					<b-tr>
						<b-th>
							<b-checkbox
								v-model="selectAllChecked"
								:indeterminate="indeterminate"
								@change="toggleAll"
							></b-checkbox>
						</b-th>
						<b-th>Disburse Date</b-th>
						<b-th>Description</b-th>
						<b-th>Bank</b-th>
						<b-th>Bank Account No</b-th>
						<b-th>Amount (RM)</b-th>
						<b-th class="text-center">Attachment</b-th>
						<b-th>Status</b-th>
						<b-th></b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr v-for="(data, index) in tableData" :key=index>
						<b-td>
							<b-checkbox
								v-model="data.selected"
								@change="updateSelection()"
								:disabled="((data.description == 'Balance Disbursement') && !is_all_debtconsole_approved)"
							></b-checkbox>
						</b-td>
						<b-td class="text-primary" :class="(data.status == 'Rejected' ? 'text-strikethrough': '')">
								{{ data.disburse_date | dateFormatString }}
						</b-td>
						<b-td class="text-primary" :class="(data.status == 'Rejected' ? 'text-strikethrough': '')">{{ data.description }}</b-td>
						<b-td class="text-primary" :class="(data.status == 'Rejected' ? 'text-strikethrough': '')">{{ data.bank_name }}</b-td>
						<b-td class="text-primary" :class="(data.status == 'Rejected' ? 'text-strikethrough': '')">{{ data.bank_account }}</b-td>
						<b-td class="text-primary" :class="(data.status == 'Rejected' ? 'text-strikethrough': '')">{{ data.amount | moneyFormatter }}</b-td>
						<b-td class="text-center">
							<div class="btn btn-icon btn-sm btn-primary rounded-circle cursor-pointer" @click="openModal(data,true)">{{ data.total_attachment }}</div>
						</b-td>
						<b-td>
							<div v-if="!_gHlp.isEmpty(data.apv_id)">
								<div class="d-flex justify-content-start align-items-center" v-if="(_gHlp.checkAccess(['role_credit_head','role_credit_manager','role_admin','role_super_admin']) || (!_gHlp.checkAccess(['disbursement_approval'])))">
										<el-button type="success" plain size="mini" @click="updateApprovalStatus(data.apv_id,'Approved')" icon="el-icon-check">
											Approve
										</el-button>
										<el-button type="danger" plain size="mini" @click="updateApprovalStatus(data.apv_id,'Rejected')" icon="el-icon-close">
											Reject
										</el-button>
								</div>
								<small v-else>
									<i>Waiting Approval</i>
								</small>
							</div>
							<div v-else>
								<!-- hide update balance before all item approved  -->
								<el-dropdown trigger="click" v-model="data.status" style="cursor: pointer;"
									:disabled="data.status != 'Pending'" @command="updateStatusDisbursement"
									v-if="!((data.description == 'Balance Disbursement') && !is_all_debtconsole_approved)"
									>
									<p class="el-dropdown-link top-line">
										<span class="d-inline-block text-truncate " :class="_gConst.getColor(data.status)"
											style="max-width: 150px; overflow: unset;">{{ data.status }}</span>
										<i class="el-icon-caret-bottom el-icon--right" v-if="data.status == 'Pending'"></i>
									</p>
									<el-dropdown-menu slot="dropdown">
										<div style="max-height: 300px;overflow-y: auto;">
											<el-dropdown-item v-for="(itm, index) in statusList" :key="index"
												:command="{ disb_id: data.disb_id, status: itm }">{{ itm }}</el-dropdown-item>
										</div>
									</el-dropdown-menu>
								</el-dropdown>
								<p class="bottom-line" :class="_gConst.getColor(data.status)" v-if="data.status == 'Approved' || data.status == 'Rejected'">
									<small><i slot="reference" class="el-icon-info" ></i> {{ data.aprv_reject_at | dateFormatString }}</small>
								</p>
							</div>
						</b-td>
						<b-td>
							<div v-if="!((data.description == 'Balance Disbursement') && !is_all_debtconsole_approved)">
								<!-- <el-dropdown trigger="click" style="cursor: pointer" v-if="data.status != 'Approved'"> -->
								<el-dropdown trigger="click" style="cursor: pointer">
									<p class="el-dropdown-link mb-0 top-line">
										<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
									</p>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item @click.native="openModal(data)">
											<!-- Eye Icon -->
											<b-icon icon="pencil-square" class="mr-1" variant="gray"></b-icon>
											Edit
										</el-dropdown-item>
										<el-dropdown-item @click.native="remove(data.disb_id)" v-if="data.status != 'Approved'">
											<span class="text-danger">
												<!-- Trash-Can Icon -->
												<b-icon icon="trash" class="mr-1" variant="gray"></b-icon>
												Delete
											</span>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</b-td>
					</b-tr>
				</b-tbody>
				<b-tfoot>
					<b-tr>
						<b-td colspan="4" rowspan="6">
							<el-select v-model="bulkStatus" placeholder="Bulk Update Status" size="mini" @change="bulkUpdateStatusDisbursement" v-if="hasSelected">
								<el-option
									v-for="(itm, index) in statusList"
									:key="index"
									:label="itm"
									:value="itm">
								</el-option>
							</el-select>
						</b-td>
						<b-td class="font-weight-600">Total</b-td>
						<b-td class="font-weight-600">{{ proposed_total | moneyFormatter }}</b-td>
						<b-td colspan="3" rowspan="6"></b-td>
					</b-tr>
					<b-tr>
						<b-td class="font-weight-600 text-danger">Rejected Amount</b-td>
						<b-td class="font-weight-600 text-danger"> - {{ rejected_amount | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr>
						<b-td class="font-weight-600">Disbursement Amount</b-td>
						<b-td class="font-weight-600">{{ disburse_total | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr>
						<b-td class="font-weight-600">Release Disbursed Amount</b-td>
						<b-td class="font-weight-600">{{ disbursed_amount | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr>
						<b-td class="font-weight-600">Remaining Disbursement Amount</b-td>
						<b-td class="font-weight-600" :class="{ 'text-danger': remaining_amount < 0 }">{{ remaining_amount | moneyFormatter }}</b-td>
					</b-tr>
				</b-tfoot>
			</b-table-simple>
		</div>

		<DrawerAccountStatement ref="drawer_account_statement" />
		<ModalAddDisbursement ref="modal_add_disbursement" @closeModal="closeModal($event)" />
	</b-card>
</template>
<script>
import { Button, Dropdown, DropdownItem, DropdownMenu, Select, Option } from 'element-ui';
import ModalAddDisbursement from '@/views/CreditLoanCase/Modals/ModalAddDisbursement';
import DrawerAccountStatement from '@/views/CreditLoanCase/Drawers/DrawerAccountStatement'
// import AttachmentListPopover from '@/views/Widgets/AttachmentListPopover'
// import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { cloneDeep } from 'lodash'
import { swal } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia';
import { useApprovalStore } from '@/stores/approvalStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useMessagingStore } from '@/stores/messagingStore';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

export default {
	components: {
		DrawerAccountStatement,
		ModalAddDisbursement,
		// AttachmentListPopover,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
	},
	// mixins: [clientPaginationMixin],
	data() {
		return {
			is_loading: false,
			selectAllChecked: false,
			bulkStatus: '',
			editData: {},
			tableData: []
		}
	},
	created() {
		this.getListing();
		gEventBus.$on('refresh-disbursements', this.getListing)
	},	
	beforeDestroy() {
		gEventBus.$off('refresh-disbursements', this.getListing)
	},
	computed:{
		...mapState(useApprovalStore, ['activeApprovalList']),
		...mapState(useLoanCaseStore, ['activeCase']),
		proposed_total() {
			return this.tableData.reduce((tot, obj) => {
				const amount = parseFloat(obj.amount);
				return tot + (isNaN(amount) ? 0 : amount);
			}, 0)
		},
		disburse_total() {
			return this.tableData.reduce((tot, obj) => {
				const amount = parseFloat(obj.amount);
				return (obj.status == 'Rejected') ? tot : tot + (isNaN(amount) ? 0 : amount)
			}, 0)
		},
		disbursed_amount() {
			return this.tableData.reduce((tot, obj) => {
				if (obj.status == 'Approved') {
					const amount = parseFloat(obj.amount);
					return tot + (isNaN(amount) ? 0 : amount)
				} else {
					return tot
				}
			}, 0)
		},
		rejected_amount() {
			return this.tableData.reduce((tot, obj) => {
				if (obj.status == 'Rejected') {
					const amount = parseFloat(obj.amount);
					return tot + (isNaN(amount) ? 0 : amount);
				} else {
					return tot
				}
			}, 0)
		},
		remaining_amount() {
			return parseFloat(_gHlp.getValue(this.activeCase, 'loan_amount', 0)) - this.disbursed_amount;
		},
		is_all_debtconsole_approved(){
			const appv_item = (this.tableData.filter(itm => ((itm.description != 'Balance Disbursement' ) && (itm.status == 'Approved')))).length;
			const non_balance_item = (this.tableData.filter(itm => ((itm.description != 'Balance Disbursement') && (itm.status != 'Rejected')))).length;
			return (appv_item == non_balance_item)
		},
		indeterminate() {
      const selectedCount = this.tableData.filter(item => item.selected).length;
			return selectedCount > 0 && selectedCount < this.tableData.length;
    },
		hasSelected() {
			return this.tableData.filter(item => item.selected).length > 0
		},
		statusList(){
			return (_gHlp.checkAccess(['role_credit_head','role_credit_manager','role_admin','role_super_admin']) || (!_gHlp.checkAccess(['disbursement_approval']))) ? ['Pending', 'Submitted','Approved','Rejected'] : ['Pending', 'Submitted'];
		}
	},
	methods: {
		...mapActions(useLoanCaseStore, ['getCase','getDisbList', 'updateDisb', 'bulkUpdateDisb', 'deleteDisb']),
		...mapActions(useApprovalStore, ['getAprovalList', 'updateApproval']),
		...mapActions(useNotificationStore, ['createBellNotif']),
		...mapActions(useMessagingStore, ['createSendEmail']),
		openModal(item = null,attachment_only=false) {
			this.$refs.modal_add_disbursement.show(cloneDeep(item),attachment_only)
		},
		closeModal(refresh = false) {
			if (refresh) {
				this.getListing();
			}
		},
		getListing() {
			this.is_loading = true;
			this.getDisbList().then(resp => {
				let tableData = resp.data
				if(!_gHlp.isEmpty(tableData)){
					tableData.forEach(item => {
						item['selected'] = false
					});
				}

				this.tableData = tableData;
				this.is_loading = false;
			}).catch(err => {
				this.is_loading = false;
			});
		},
		toggleAll() {
      const isSelected = this.selectAllChecked;
			let tableData = cloneDeep(this.tableData);
			tableData.forEach(item => {
				item.selected = !((item.description == 'Balance Disbursement') && !this.is_all_debtconsole_approved) ? isSelected : false; 
      });
			this.tableData = tableData
    },
		updateSelection() {
			let tableData = cloneDeep(this.tableData);
			const selectedCount = this.tableData.filter(item => item.selected).length;
      if (selectedCount === this.tableData.length) {
        this.selectAllChecked = true;
      } else if (selectedCount > 0) {
        this.selectAllChecked = false;
      } else {
        this.selectAllChecked = false;
      }
			this.tableData = tableData
    },
		updateStatusDisbursement(val) {
			let disb_id = val.disb_id;
			let status = val.status;

			swal.fire({
				title: 'Status Change',
				text: "Confirm change to " + status,
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					this.updateDisb(disb_id, { status: status }).then(res => {
						if(status == 'Submitted'){
							this.createBellNotif('LMS_CASE_DISBURSEMENT_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
							this.createSendEmail('LMS_CASE_DISBURSEMENT_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
						}else if(status == 'Approved'){
							this.createBellNotif('LMS_CASE_DISBURSEMENT_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
							this.createSendEmail('LMS_CASE_DISBURSEMENT_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
						}

						_gNotif.notifySuccess("Disbursement status has been update")
						this.getListing();
						gEventBus.$emit('refresh-cases')
						this.is_loading = false
					});
				}
			})

		},
		bulkUpdateStatusDisbursement(status){
			let selected = this.tableData.filter(item => item.selected);
			if(_gHlp.isEmpty(selected)) return false;

			let params = {
				disb_ids: selected.map(item => item.disb_id),
				status: status
			}

			swal.fire({
				title: 'Status Change',
				text: "Confirm change selected items status to " + status,
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;

					this.bulkUpdateDisb(params).then(res => {
						if(status == 'Submitted'){
							this.createBellNotif('LMS_CASE_DISBURSEMENT_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
							this.createSendEmail('LMS_CASE_DISBURSEMENT_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
						}else if(status == 'Approved'){
							this.createBellNotif('LMS_CASE_DISBURSEMENT_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
							this.createSendEmail('LMS_CASE_DISBURSEMENT_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
						}

						_gNotif.notifySuccess("Disbursement status has been update")
						this.getListing();
						gEventBus.$emit('refresh-cases')
						this.bulkStatus = ''
						this.is_loading = false
					});
				}
			})
		},
		remove(id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteDisb(id).then(resp => {
						this.getListing();
						gEventBus.$emit('refresh-cases')
						_gNotif.notifySuccess('<b>Disbursement: </b> - Successfully Deleted.')
					});
				}
			})

		},
		updateApprovalStatus(apv_id,status){
			swal.fire({
				title: 'Approval Confirmation',
				text: "Confirm to " + status + " this request ?",
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					let params = { 
						approve_status: status,
						approve_at: _gHlp.getCurrentDateTime(),
						approve_by: _gAuth.activeUser('id',null)
					}
					this.updateApproval(apv_id, params).then(resp => {
						this.createBellNotif('LMS_CASE_DISBURSEMENT_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
						this.createSendEmail('LMS_CASE_DISBURSEMENT_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
						this.getCase().then(resp => {
							this.getListing();
							_gNotif.notifySuccess("Approval Request for disbursement has been "+status);
							this.is_loading = false;
						}).catch(err => {
							this.is_loading = false;
						});
					}).catch(err => {
						this.is_loading = false;
					});
				}
			});
		},
	}
}
</script>